import { Grid2, Typography } from "@mui/material";
import React from "react";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { SelectCreateCard } from "../style";
import CommonTextField from "../../../component/Input";
import SearchIcon from "@mui/icons-material/Search";
import CommonAccordion from "../../common-components/CommonAccordion";
import { HandleSkeletion } from "../../../utils/constants";

export default function QuickLink({
  filteredQuickLink,
  handleQuickLinkNavigate,
  handleSearchQuickLink,
  searchHarizon,
  helpFiltered,
  handleHelpAccord,
  isLoading,
  checkWidth,
}) {
  return (
    <CommonGrid2 size={12}>
      {isLoading ? (
        <HandleSkeletion height={70} width={"200px"} />
      ) : (
        <CommonTextField
          placeholder="Search anything in home"
          startIcon={<SearchIcon />}
          padding={"12px 10px"}
          customStyle={{
            "& .MuiInputBase-root": {
              width: "50%",
            },
          }}
          value={searchHarizon.search}
          onChange={handleSearchQuickLink}
        />
      )}

      <CommonGrid2 container spacing={2} marginTop={"1.5rem"}>
        {filteredQuickLink.map((item, index) => (
          <Grid2
            item
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: checkWidth < 800 ? 4 : 3,
              xl: checkWidth < 1000 ? 3 : 2.4,
            }}
          >
            {isLoading ? (
              <HandleSkeletion
                height={80}
                width={"100%"}
                transform="scale(1)"
              />
            ) : (
              <SelectCreateCard
                key={index}
                minHeight="100%"
                gap="10px"
                padding="12px"
                justifyContent="flex-start"
                condition={item.disabled && false}
                onClick={() =>
                  item.disabled ? {} : handleQuickLinkNavigate(item.navigate)
                }
              >
                <CustomDiv>{item.icon}</CustomDiv>
                <CustomDiv>
                  <Typography
                    color="#354A5F"
                    variant="h6"
                    fontSize={"15px"}
                    fontWeight={600}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    color="#5B738B"
                    fontSize={"14px"}
                    fontWeight={500}
                  >
                    {item.description}
                  </Typography>
                </CustomDiv>
              </SelectCreateCard>
            )}
          </Grid2>
        ))}
      </CommonGrid2>

      {helpFiltered.length !== 0 && (
        <Grid2 size={12} fontFamily={"Inter"} margin={"1.5rem 0px 0px"}>
          <CommonAccordion
            title={"Help"}
            open={searchHarizon.helpAccord}
            onChange={handleHelpAccord}
            children={
              <CommonGrid2 container spacing={2} marginTop={"10px"}>
                {helpFiltered.map((item, index) => (
                  <Grid2
                    item
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 4,
                      lg: checkWidth < 800 ? 4 : 3,
                      xl: checkWidth < 1000 ? 3 : 2.4,
                    }}
                  >
                    {isLoading ? (
                      <HandleSkeletion
                        height={80}
                        width={"100%"}
                        transform="scale(1)"
                      />
                    ) : (
                      <SelectCreateCard
                        key={index}
                        minHeight="100%"
                        gap="10px"
                        padding="12px"
                        justifyContent="flex-start"
                        onClick={() =>
                          item.onClick
                            ? item.onClick()
                            : handleQuickLinkNavigate(item.navigate)
                        }
                      >
                        <CustomDiv>{item.icon}</CustomDiv>
                        <CustomDiv>
                          <Typography
                            color="#354A5F"
                            variant="h6"
                            fontSize={"15px"}
                            fontWeight={600}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            color="#5B738B"
                            fontSize={"14px"}
                            fontWeight={500}
                          >
                            {item.description}
                          </Typography>
                        </CustomDiv>
                      </SelectCreateCard>
                    )}
                  </Grid2>
                ))}
              </CommonGrid2>
            }
          />
        </Grid2>
      )}
    </CommonGrid2>
  );
}
